export default __webpack_public_path__ + "a6f907b627b45c09dcb4382ffec648e5.woff";